import React from 'react';
import { ChatMessagesContext } from './ChatMessagesContext';
/**
 * Provider component that wraps child components with the ChatMessagesContext.
 * @public
 */
export const ChatMessagesProvider = ({
  children,
  value
}) => {
  return React.createElement(ChatMessagesContext.Provider, {
    value: value
  }, children);
};